/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots8VIcon16Regular = forwardRef('UiMenuDots8VIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6 3.996A1.248 1.248 0 1 0 6 1.5a1.248 1.248 0 0 0 0 2.496Z" }),
        React.createElement("path", { d: "M6.002 11a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" }),
        React.createElement("path", { d: "M7.248 6.245a1.248 1.248 0 1 1-2.496 0 1.248 1.248 0 0 1 2.496 0Z" }),
        React.createElement("path", { d: "M6 14.497A1.248 1.248 0 1 0 6 12a1.248 1.248 0 0 0 0 2.497Z" }),
        React.createElement("path", { d: "M11.248 2.748a1.248 1.248 0 1 1-2.496 0 1.248 1.248 0 0 1 2.496 0Z" }),
        React.createElement("path", { d: "M10.002 11a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" }),
        React.createElement("path", { d: "M11.248 6.245a1.248 1.248 0 1 1-2.496 0 1.248 1.248 0 0 1 2.496 0Z" }),
        React.createElement("path", { d: "M10 14.497A1.248 1.248 0 1 0 10 12a1.248 1.248 0 0 0 0 2.497Z" })));
});
